import firebase from "firebase";

// ------------------------------- helper functions

export function createGuid() {
	var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
	return guid;
}

export function createGuidRight5(pos = 5) {
	var guid = createGuid();
	guid = guid.substr(guid.length - pos);
	return guid;
}

export function createGuidRight5a() {
	var guid = createGuid();
	guid = "a" + guid.substr(guid.length - 5);
	return guid;
}



// ---------- COMMON  LOCAL --------------------

function getProjectRef(pid) {
	const db = firebase.firestore();
	return db.collection("projects").doc(pid);
}

async function updateProjectProperty(pid, newObj) {
	await getProjectRef(pid).update(newObj);
}

async function deleteProjectPropertyItem(pid, objRef) {
	await getProjectRef(pid).update({ [objRef]: firebase.firestore.FieldValue.delete() });
}

function getPropID(context) {
	if (context == "workItems") return 'wiid';
	if (context == "expenses") return 'exid';
	if (context == "invoices") return 'inid';
	if (context == "timesheets") return 'tiid';
	return "";
}

// ------------------------------- CLIENTS

export async function createClient(client) {
	try {
		const db = firebase.firestore();
		let clientsRef = db.collection("clients");
		var docRef = await clientsRef.add(client);
		return docRef.id;
	}
	catch (error) {
		debugger;
		console.log("createClient", error);
	}
}

export async function updateClient(client) {
	const db = firebase.firestore();
	let clientsRef = db.collection("clients").doc(client.cid);
	await clientsRef.update(client);
}

export async function deleteClient(client) {
	const db = firebase.firestore();
	let clientsRef = db.collection("clients").doc(client.cid);
	await clientsRef.delete();
}

// retrieve all clients for the given user (uid)
export async function getClients(uid) {

	const db = firebase.firestore();
	var clientsRef = db.collection("clients");

	// Create a query against the collection.
	var query = clientsRef.where("uid", "==", uid);
	let querySnapshot = await query.get();

	let clients = [];
	querySnapshot.forEach(function (doc) {
		let tempClient = doc.data();
		tempClient.cid = doc.id;
		clients.push(tempClient);
	});

	return clients;
}


// ------------------------------- USERS

export async function getUserInfo(uid) {

	try {
		//debugger;
		console.log("uid=" + uid);

		const db = firebase.firestore();
		//var user = firebase.auth().currentUser;

		// NOTE - TODO - work out why this fails if there is no row in the users collection
		// for this uid - it throws a permission error??????
		// Create a reference to our own users collection
		//var usersDoc = db.collection("users").doc(uid);
		//var usersDoc = db.collection('users').where(firebase.firestore.FieldPath.documentId(), '==', uid);
		var usersDoc = db.collection('users').where("uid", '==', uid);
		let docref = await usersDoc.get();

		// if we found a match - match on > 0 (hunch in case we accidentaly have more rows)
		if (docref.size > 0) {
			let user = docref.docs[0].data();
			return user;
		}
		else {
			return null;
		}
	}
	catch (error) {
		console.error("Error in getUserInfo: " + error);
		debugger;
		return "error";
	}
	return null;
}

export async function createUserInfo(uid, obj) {

	try {
		const db = firebase.firestore();

		// Create a reference to our own users collection
		await db.collection("users").doc(uid).set(obj);

		return await getUserInfo(uid);

	}
	catch (error) {
		debugger;
		console.error("Error in createUserInfo: " + error);
	}
	return null;

}

export async function updateUserInfo(uid, obj) {

	const db = firebase.firestore();

	// Create a reference to our own users collection
	var usersDoc = db.collection("users").doc(uid);
	let docref = await usersDoc.get();

	if (docref.exists) {
		console.log(obj);
		await usersDoc.update(obj);
	}

}


// ------------------------------- PROJECTS

// retrieve all projects for the given user (uid)
export async function getProjects(uid) {

	const db = firebase.firestore();
	var projectsRef = db.collection("projects");

	// Create a query against the collection.
	var query = projectsRef.where("uid", "==", uid);
	let querySnapshot = await query.get();

	let projects = [];
	querySnapshot.forEach(function (doc) {
		let tempProject = doc.data();
		tempProject.pid = doc.id;
		projects.push(tempProject);
	});

	return projects;
}

export async function createProject(project) {
	try {
		const db = firebase.firestore();
		let projectsRef = db.collection("projects");
		var docRef = await projectsRef.add(project);
		return docRef.id;
	}
	catch (error) {
		debugger;
		console.log("createProject", error);
	}
}

// this function will update all project top level properties
export async function updateProject(miniProject) {
	await updateProjectProperty(miniProject.pid, miniProject);
}

export async function deleteProject(client) {
	const db = firebase.firestore();
	let clientsRef = db.collection("clients").doc(client.cid);
	await clientsRef.delete();
}

// ------------------------------- GENERIC PROJECT OBJECT ITEMS


export async function createObjItem(pid, obj) {
	let item = obj.item;
	let propId = getPropID(obj.context);
	item[propId] = createGuidRight5();	// define a new id for the correct props and asign it to the item AND use it as the pushID
	let newObj = { [`${obj.context}.${item[propId]}`]: item };
	await updateProjectProperty(pid, newObj);
}

export async function updateObjItem(pid, obj) {
	let item = obj.item;
	let propId = getPropID(obj.context);
	if (!item.hasOwnProperty(propId))
		item[propId] = createGuidRight5();

	let newObj = { [`${obj.context}.${item[propId]}`]: item };
	await updateProjectProperty(pid, newObj);
}

export async function deleteObjItem(pid, obj) {
	let item = obj.item;
	let propId = getPropID(obj.context);
	if (!item.hasOwnProperty(propId)) return;
	deleteProjectPropertyItem(pid, `${obj.context}.${item[propId]}`);
}

export async function getCurrentObjItems(pid, context) {
	let snapshot = await getProjectRef(pid).get();
	return snapshot.data()[context];
}

// export { createClient, updateClient, deleteClient, getClients, getProjects };

